import ConfirmDialogData from "../ConfirmDialog/ConfirmDialogData";

const VesselCommentsStore = {
	confirmDialog: new ConfirmDialogData()
};
export default VesselCommentsStore;
